import { KineticText } from "@/components/KineticText";
import { Reveal } from "@/components/Reveal";

export const PageHero = ({ chapter, tag, lines, lead, testId }) => (
  <section className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto pt-36 pb-14 sm:pb-20" data-testid={testId}>
    <div className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.25em] text-fog">
      {chapter && <span className="text-amber">{chapter}</span>}
      <span className="h-px w-10 bg-forest/20" />
      <span>{tag}</span>
    </div>
    <h1 className="mt-7 font-display font-extrabold tracking-tight leading-[1.04] text-4xl sm:text-5xl lg:text-6xl text-forest max-w-4xl">
      <KineticText lines={lines} />
    </h1>
    {lead && (
      <Reveal delay={0.45} className="mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-moss">
        {lead}
      </Reveal>
    )}
  </section>
);
